export default "__VITE_ASSET__93a4bca0__"